export const selectMessages = state => {
  return state.liveChat.messages;
};
export const selectChannels = state => {
  return state.liveChat.channels;
};
export const selectChatSessions = state => {
  return state.liveChat.sessions;
};
export const selectDialogueUsers = state => {
  return state.liveChat.dialogueUsers;
};
export const selectCurrentChat = state => {
  return state.liveChat.currentChat;
};
export const selectMessagesPagination = state => {
  return state.liveChat.messagesPagination;
};
